module.exports = __webpack_public_path__ + "static/bannner-internacionalismo-3-80f5b67c4db23832c437389a868f15ec.jpeg";